<template>
    <div>
        <v-card class="consignment" @click="toggle">
            <v-card-title>위탁판매(+4,000원)</v-card-title>
            <v-checkbox v-model="isConsigned" v-bind="attrs_input2" @click.stop></v-checkbox>
        </v-card>
        <p class="consignment-hint">위탁판매 시 배송대행비 및 택배비는 주문 건별 즉시 결제입니다.</p>
    </div>
</template>

<script>
import { attrs_input2 } from "@/assets/variables";

export default {
    components: {},
    props: {
        value: { type: Boolean, default: false },
    },
    setup: () => ({
        attrs_input2,
    }),
    data: () => ({
        isConsigned: false,
    }),
    computed: {},
    methods: {
        sync() {
            this.isConsigned = this.value;
        },
        emit() {
            this.$emit("input", this.isConsigned);
        },
        toggle() {
            this.isConsigned = !this.isConsigned;
        },
    },
    watch: {
        value() {
            this.sync();
        },
        isConsigned() {
            this.emit();
        },
    },
    mounted() {
        this.sync();
    },
    beforeUnmount() {},
};
</script>

<style lang="scss" scoped>
.consignment,
.consignment-hint {
    padding: var(--input-padding);
}
.consignment {
    height: var(--input-height);
    border-width: 1px;
    border-style: solid;
    border-color: var(--border-color);
    border-radius: var(--input-border-radius) !important;
    display: flex;
    justify-content: space-between;
    align-items: center;
    transition: border 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    cursor: pointer;
    > .v-card__title {
        padding: 16px 0;
        font-size: var(--input-font-size);
        line-height: 1;
        font-weight: 400;
        color: var(--v-grey-lighten1);
    }
    ::v-deep(.v-input--selection-controls__input) {
        margin: 0;
    }
    &:hover {
        border-color: var(--v-grey-darken4);
    }
    &::before {
        display: none;
    }
}
.consignment-hint {
    font-size: 12px;
    line-height: 16px;
    margin-top: 8px;
    color: var(--v-grey-lighten1);
}
</style>
